/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getWishListsDataView } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import translate from "@insite/client-framework/Translate";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { xScreen } from "@rc/XDL/Utilities";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    return {
        wishLists: getWishListsDataView(state, state.pages.myLists.getWishListsParameter)?.value,
    };
};
const MyListsResultCount = ({ wishLists }: WidgetProps & ReturnType<typeof mapStateToProps>) => {
    return (
        <Typography
            css={css`
                height: 51px;
                display: flex;
                align-items: center;
                color: ${getColor("common.ui6")};
                font-size: 18px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 24px;
                ${xScreen("lt", "sm")} {
                    height: auto;
                }
            `}
            data-test-selector="mylists_resultCount"
        >
            {!wishLists || !wishLists.length ? "0" : wishLists?.length} {translate("Lists")}
        </Typography>
    );
};

export const definition: WidgetDefinition = {
    group: "My Lists",
    displayName: "My Lists Result Count",
    allowedContexts: ["MyListsPage"],
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(MyListsResultCount),
    definition,
};

export default widgetModule;
